export const SHOPPING_CART_CONSTANTS = { // TODO llevar a localized
  TITLE: 'Resumen del pedido',
  FINAL_COST_TEXT: 'Total',
  FINAL_COST_BEFORE_DISCOUNTS_TEXT: 'Precio total sin promoción',
  RECURRING_CHARGES_UNITY: '€/mes',
  ONE_TIME_CHARGES_UNITY: '€',
  CHANGE_NOTICE_BEST_PRICE_TITTLE: 'Buenas noticias',
  CHANGE_NOTICE_WORST_PRICE_TITTLE: 'Aviso: Cambio de precio',
  CHANGE_NOTICE_BEST_PRICE_TEXT:
    'Tenemos una mejor oferta de este producto a la que puedes acogerte. Revisa el precio de tu carrito',
  CHANGE_NOTICE_WORST_PRICE_TEXT:
    'Tras revisar tus datos el precio del producto que has seleccionado ha variado',
  CHANGE_PRICE_NOTICE_BUTTON: 'ACEPTAR',
  TAXES_BAND: 'Precios con impuestos incluidos',
  DOWNGRADE_TEXT: 'Baja',
};
